import { debounce } from 'lodash';
import { Dispatch } from 'redux';
import { TaskId } from 'api/models';
import { fetchTaskSaga } from 'data/tasks/actions';

export const debouncedFetchTaskSaga = debounce(
  ([, projectId, taskId]: TaskId, dispatch: Dispatch) => {
    return dispatch(
      fetchTaskSaga({
        projectId,
        taskId,
        fetchInBackground: true,
      }),
    );
  },
  100,
);
